import DataTable from "@/components/admin/DataTable";
import { adminApi } from "@/lib/adminApi";

const partLabel = {
  avec_problematique: "Avec problématique",
  representant: "Représentant",
};

const columns = [
  { key: "created_at", label: "Reçu le", format: "date" },
  {
    key: "nom",
    label: "Personne",
    render: (it) => (
      <div>
        <div className="font-medium">
          {it.prenom} {it.nom}
        </div>
        <div className="text-xs text-[#5F6170] mt-0.5">{it.email}</div>
        {it.telephone && (
          <div className="text-xs text-[#5F6170]">{it.telephone}</div>
        )}
      </div>
    ),
  },
  {
    key: "workshop_id",
    label: "Atelier",
    render: (it) => <span className="text-[#3A2E6E]">{it.workshop_id}</span>,
  },
  {
    key: "participation_type",
    label: "Rôle",
    render: (it) => (
      <span className="text-xs uppercase tracking-[0.14em] text-[#C98FA3] font-medium">
        {partLabel[it.participation_type] || it.participation_type}
      </span>
    ),
  },
  {
    key: "message",
    label: "Message",
    render: (it) => (
      <div className="max-w-xs text-xs text-[#5F6170]">
        {it.message || <span className="italic">—</span>}
      </div>
    ),
  },
];

export default function RegistrationsList() {
  return (
    <DataTable
      testId="admin-registrations"
      title="Inscriptions ateliers"
      subtitle="Toutes les pré-inscriptions reçues, les plus récentes en premier."
      fetcher={adminApi.listRegistrations}
      columns={columns}
    />
  );
}
